import React, { useRef, useCallback } from "react";
import { Drawer, Form, Input, Button } from "antd";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { ENDPOINT } from "../../../Services/ENDPOINT";
import { ComplaintService } from "../../../Services/Manage/ComplaintService";

const complaintQuillModules = {
    toolbar: [
        [{ font: [] }],
        [{ header: [1, 2, 3, 4, 5, 6, false] }],
        [{ align: [] }],
        ["bold", "italic", "underline", "strike"],
        [{ color: [] }, { background: [] }],
        [{ script: "sub" }, { script: "super" }],
        ["blockquote", "code-block"],
        [{ list: "ordered" }, { list: "bullet" }],
        [{ indent: "-1" }, { indent: "+1" }],
        ["link", "image"],
        ["clean"],
    ],
};

const CreateComplaint = ({
    visible,
    onClose,
    onFinish,
    form,
    editingItem,
}) => {
    return (
        <Drawer
            title={editingItem ? "Edit Complaint" : "Raise New Complaint"}
            width={900}
            onClose={onClose}
            open={visible}
            bodyStyle={{ paddingBottom: 80 }}
        >
            <Form form={form} layout="vertical" onFinish={onFinish}>
                {/* Subject */}
                <Form.Item
                    name="title"
                    label="Subject"
                    rules={[{ required: true, message: "Please enter subject" }]}
                >
                    <Input
                        size="large"
                        placeholder="Subject"
                        variant="borderless"
                        style={{
                            borderBottom: "1px solid #e8e8e8",
                            borderRadius: 0,
                            paddingLeft: 0,
                        }}
                    />
                </Form.Item>

                {/* Rich text description */}
                <Form.Item
                    name="description"
             
                >
                    <QuillField />
                </Form.Item>

                {/* Thin divider line above Status */}
                {/* <Divider style={{ margin: "12px 0" }} />

          
                <Form.Item name="status" label="Status" valuePropName="checked">
                    <Switch
                        size="medium"
                        checkedChildren="Active"
                        unCheckedChildren="Inactive"
                    />
                </Form.Item> */}

                {/* Buttons */}
                <Form.Item>
                    <div
                        style={{
                            textAlign: "right",
                            display: "flex",
                            gap: "10px",
                            justifyContent: "flex-end",
                        }}
                    >
                        <Button size="large" type="primary" htmlType="submit">
                            {editingItem ? "Update" : "Raise"}
                        </Button>
                        <Button size="large" onClick={onClose}>
                            Cancel
                        </Button>
                    </div>
                </Form.Item>
            </Form>
        </Drawer>
    );
};



const QuillField = ({ value, onChange }) => {
    const quillRef = useRef(null);
    const modulesRef = useRef(null);

    const imageHandler = useCallback(() => {
        const input = document.createElement("input");
        input.setAttribute("type", "file");
        input.setAttribute("accept", "image/*");
        input.click();
        input.onchange = async () => {
            const file = input.files[0];
            if (!file) return;
            try {
                const res = await ComplaintService.uploadImage(file);
                if (res.success && res.data?.path) {
                    const quill = quillRef.current.getEditor();
                    const range = quill.getSelection();
                    quill.insertEmbed(range.index, "image", `${ENDPOINT.base}/${res.data.path}`);
                }
            } catch (err) {
                console.error("Image upload failed", err);
            }
        };
    }, []);

if (!modulesRef.current) {
        modulesRef.current = {
            ...complaintQuillModules,
            toolbar: {
                container: complaintQuillModules.toolbar,
                handlers: { image: imageHandler },
            },
        };
    }

    return (
        <div className="complaint-quill">
            <ReactQuill
                ref={quillRef}
                theme="snow"
                value={value || ""}
                onChange={onChange}
                modules={modulesRef.current}
                placeholder="Write your complaint here..."
            />
        </div>
    );
};

export default CreateComplaint;